import { computed, shallowRef, type ComputedRef } from "vue";

// The create modal lives in the annotations mode's persistent host (outside
// the docked/overlay branches); the header "+" and the body's empty-state
// link are separate components, so both reach it through this registration.
const opener = shallowRef<(() => void) | null>(null);

export function registerAnnotationCreateOpener(open: () => void): () => void {
  opener.value = open;
  return () => {
    // A remounted host may have registered before this one unmounted.
    if (opener.value === open) opener.value = null;
  };
}

export function useAnnotationCreateOpener(): ComputedRef<(() => void) | null> {
  return computed(() => opener.value);
}
